var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"chart-mails-sent"},[(!_vm.hasLoaded)?_c('loader'):_vm._e(),_c('div',{staticClass:"chart"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }